import { Suspense, lazy } from 'react';
import type { FormGatingSelectProps } from './FormGatingSelect';
import type { FormRendererProps } from './RenderV2';

const FormGatingSelectImport = lazy(
  () => import(/* webpackChunkName: "components/form/gating-select" */ '@/Components/form/FormGatingSelect')
);

const FormGatingSelect = (props: FormGatingSelectProps) => {
  return (
    <Suspense fallback={<div>Loading...</div>}>
      <FormGatingSelectImport {...props} />
    </Suspense>
  );
};

const FormRenderImport = lazy(
  () => import(/* webpackChunkName: "components/form/render" */ '@/Components/form/RenderV2')
);

const FormRendererV2 = (props: FormRendererProps) => {
  return (
    <Suspense fallback={<div />}>
      <FormRenderImport {...props} />
    </Suspense>
  );
};

export { FormGatingSelect, type FormGatingSelectProps, FormRendererV2, type FormRendererProps as FormRendererV2Props };
